export const SET_REMINDER_SCHEDULES = "SET_REMINDER_SCHEDULES";
export const SET_TIME_ZONE = "SET_TIME_ZONE";
